//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiAccountOutline } from '@mdi/js'

export default {
  setup() {
    return { icons: { mdiAccountOutline } }
  },
}
